import React from "react";
import Row from "react-bootstrap/Row";
import config from "../../../config/config";
import { Translation } from "react-i18next";
import { ecommerceService } from "../../../services/ecommerce/EcommerceService"
import CardProduct from "../../../components/Products/CardProduct/CardProduct";
import { connect } from "react-redux"
import { handleError } from "../../../utils/handleCatch";

class FeaturedProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            products: []
        };
    }

    componentDidMount() {
        const storeId = this.props.cart ? this.props.cart.storeId : config.DEFAULT_STORE_ID;
        ecommerceService.featuredProducts(storeId).then(response => {
            this.setState({
                isLoaded: true,
                products: response.data
            })
        })
        .catch(error => {
            handleError(error)
            console.log(error);
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const storeId = this.props.cart ? this.props.cart.storeId : config.DEFAULT_STORE_ID;
        if (nextProps && nextProps.cart) {
            if (storeId !== nextProps.cart.storeId) {
                ecommerceService.featuredProducts(nextProps.cart.storeId).then(response => {
                    this.setState({
                        isLoaded: true,
                        products: response.data
                    })
                });
            }
        } else {
            ecommerceService.featuredProducts(config.DEFAULT_STORE_ID).then(response => {
                this.setState({
                    isLoaded: true,
                    products: response.data
                })
            });
        }
    }

    render() {
        const { products, isLoaded } = this.state;
        if (isLoaded) {
            return (
                <Translation>
                    {t =>
                        <div>
                            <div className="featured-section-title">Prodotti in evidenza</div>
                            <div className="container-fluid search-product-view" style={{ paddingTop: 'unset' }}>
                                <div className="row h-100 no-gutters">
                                    <div className="container-fluid px-0 max-product-row">
                                        <Row className="d-flex justify-content-center">
                                            {products && products.map((item) => (
                                                <CardProduct colStyle={true} key={item.id} item={item} />
                                            ))}
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Translation>
            );
        } else {
            return null;
        }
    }
}


const mapStateToProps = state => {
    return {
        cart: state.cart.cart
    };
}

export default connect(mapStateToProps)(FeaturedProducts);
